import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme"
export default class extends Controller {
  connect() {
  }
  initialize() {
    this.apply()
  }

  apply() {
    document.documentElement.setAttribute('data-theme', this.theme)
  }

  switch(event) {
    this.theme = event.target.dataset.themeValue
    this.apply()
  }

  get systemDefault() {
    return 'cupcake'
  }

  get theme() {
    return window.localStorage.getItem('theme') || (this.theme = this.systemDefault)
  }

  set theme(value) {
    window.localStorage.setItem('theme', value)
  }
}
